import { useQuery } from '@tanstack/react-query';
import { getMKEERAPublicData, type MKEERAPublicDataResponse } from '../../../api/MKEERA';

interface IMKEERAHookProps {
  params: {
    applicationId: string;
    perPage?: number;
    page?: number;
  };
  onSuccess?: (data: MKEERAPublicDataResponse) => void;
  onError?: (error: any) => void;
  enabled?: boolean;
}

export const useMKEERAPublicData = ({ params, onSuccess, onError, enabled = true }: IMKEERAHookProps) => {
  return useQuery<MKEERAPublicDataResponse>(['get-mkeera-public-data', params], () => getMKEERAPublicData(params), {
    onSuccess,
    onError,
    enabled,
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    retry: 3,
  });
};
